import { Outlet } from 'react-router-dom';

export const ProviderEmployeeOutlet = () => <Outlet />;
